<template>
    <div id="frame">
        <clock class="clock"></clock>
        <component
            :is="currentSlide.type"
            :data="currentSlide.data"
            ref="primarySlide"
            class="primary-slide"
        ></component>
        <component :is="'GoogleSlide'" ref="secondarySlide" class="secondary-slide"></component>
    </div>
</template>

<script>

    import vue from "vue";
    import axios from "axios";

    import numeral from "numeral";

    vue.filter("formatNumber", function(value) {
        return numeral(value).format();
    });

    import Clock from "./components/Clock.vue";
    import BlackSlide from "./components/BlackSlide.vue";
    import TextSlide from "./components/TextSlide.vue";
    import IconSlide from "./components/IconSlide.vue";
    import NumberSlide from "./components/NumberSlide.vue";
    import GoogleSlide from "./components/GoogleSlide.vue";

    export default {
        components: {
            Clock,
            BlackSlide,
            TextSlide,
            IconSlide,
            NumberSlide,
            GoogleSlide
        },

        data: function() {
            return {
                currentSlide: { type: "BlackSlide", duration: 5000, data: {} },
                currentSlideIndex: -1,
                slides: []
            };
        },

        methods: {
            /*
             * Resize the frame to fit the screen resolution
             */

            scaleFrame: function() {
                setTimeout(function() {
                    var frame = document.getElementById("frame");
                    var factor = window.innerWidth / 1920;

                    frame.style.webkitTransform = "scale(" + factor + ")";
                    frame.style.transform = "scale(" + factor + ")";
                    frame.style.top =
                        (window.innerHeight - factor * 1080) / 2 + "px";
                });
            },

            /*
             * Load slides
             */

            loadSlides: function() {
                axios.get("//tv.semetis.com/slides.php").then(
                    function(response) {
                        this.$set(this, "slides", response.data.slides);
                    }.bind(this)
                );

                setTimeout(this.loadSlides, 1000000);
            },

            /*
             * Show the next slide
             */

            showNextSlide: function() {
                /*
                 * Get the next slide index
                 */

                this.currentSlideIndex++;

                if (!this.slides[this.currentSlideIndex]) {
                    this.currentSlideIndex = 0;
                }

                /*
                 * Cut through black
                 */

                this.currentSlide = {
                    type: "BlackSlide",
                    duration: 0,
                    data: {}
                };

                /*
                 * Load the next slide and fall back to the test card
                 */

                this.currentSlide = this.slides[this.currentSlideIndex] || {
                    type: "BlackSlide",
                    duration: 5000,
                    data: {}
                };

                /*
                 * Animate in if available
                 */

                setTimeout(
                    function() {
                        this.$refs.primarySlide &&
                            this.$refs.primarySlide.buildIn &&
                            this.$refs.primarySlide.buildIn();
                    }.bind(this),
                    1000
                );

                /*
                 * Animate out if available
                 */

                setTimeout(
                    function() {
                        this.$refs.primarySlide &&
                            this.$refs.primarySlide.buildOut &&
                            this.$refs.primarySlide.buildOut();
                    }.bind(this),
                    this.currentSlide.duration - 1000
                );

                /*
                 * Load the next slide
                 */

                setTimeout(this.showNextSlide, this.currentSlide.duration);
            }
        },

        mounted: function() {
            /*
             * Resize the frame on resize
             */

            window.addEventListener("resize", this.scaleFrame);

            /*
             * Set the initial frame size
             */

            this.scaleFrame();

            /*
             * Load slides
             */

            this.loadSlides();

            /*
             * Show the first slide
             */

            this.showNextSlide();

            /*
             * Reload every 2 hours
             */

            setTimeout(function()
            {
                location.reload(true);
            }, 7200000)
        }
    };
</script>

<style lang="scss">
    @import url("https://fonts.googleapis.com/css?family=Livvic:400,700&display=swap");

    body,
    html {
        background-color: #000000;

        width: 100vw;
        height: 100vh;

        margin: 0;
        padding: 0;

        overflow: hidden;

        cursor: none;

        font-family: "Livvic", sans-serif;
        color: #ffffff;
        text-shadow: 3px 3px 10px #00000099;
        line-height: 1.25;
    }

    #frame {
        position: absolute;

        top: 0;
        left: 0;

        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
        pointer-events: none;

        width: 1920px;
        height: 1080px;

        overflow: hidden;

        background-image: url(/img/semetis_logo.svg);
        background-position: calc(1158px - 50%) 50%;
        background-repeat: no-repeat;
        background-size: 20%;

        background-color: #e45157;
    }

    .clock {
        position: absolute;

        top: 100px;
        left: 100px;

        z-index: 300;
    }

    .primary-slide {
        position: absolute;

        top: 0;
        left: 0;

        width: 1158px;
        height: 1080px;

        z-index: 100;
    }

    .secondary-slide {
        position: absolute;

        top: 0;
        right: 0;

        width: 762px;
        height: 1080px;

        z-index: 200;
    }

    .fade-enter-active {
        transition: all 1s ease;
    }
    .fade-leave-active {
        transition: all 1s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
